<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'MetaHeader',
    props: {
      showTitle: Boolean,
      baseHeader: Boolean,
      customTitle: String,
      hideDescription: Boolean,
    },
    computed: {
      ...mapState('auth', { isAuthenticated: 'status' }),
      ...mapState('auth', [
        'signup_config',
        'settings',
      ]),
      titleToShow() {
        return this.showTitle && (this.customTitle || this.$t('login.title'))
      },
      descriptionToShow() {
        return !this.hideDescription && this.$t('login.desc')
      },
      getHeaderVariant() {
        return this.signup_config && this.signup_config.type === 'variant' ?
          'default' :
          this.settings && this.settings.base_options && this.settings.base_options.meta_header_variant
      },
    },
  }
</script>
